import React from 'react'
import { Link } from "react-router-dom";

const ChargeValueItrUI = ({ chargeValueITR, onDetailsClick, details }) =>
  <div id='chargeValueItr' className='g_m_top_200'>
    <span className='g_flex_h'>
      <b className='g_large'>Charge Value using ITR</b>
      <Link to='#' onClick={onDetailsClick}>Details</Link>
    </span>
    <table className='g_table g_m_top_100'>
      <tbody>
        {
          chargeValueITR &&
          <>
            <RowUI
              cvc='chargeValueFormula'
              value={chargeValueITR.chargeValueF4}
              formula={chargeValueITR.chargeValueFormula}
              total={true}
              details={details}
            />
            <RowUI
              cvc='assetTotal'
              value={chargeValueITR.assetTotalF4}
              total={true}
              details={details}
            />
            <RowUI
              cvc='asset1Value'
              value={chargeValueITR.asset1ValueF4}
              formula={chargeValueITR.asset1Formula}
              details={details}
            />
            <RowUI
              cvc='asset2Value'
              value={chargeValueITR.asset2ValueF4}
              formula={chargeValueITR.asset2Formula}
              details={details}
            />
            <RowUI
              cvc='asset3Value'
              value={chargeValueITR.asset3ValueF4}
              formula={chargeValueITR.asset3Formula}
              details={details}
            />
            <RowUI
              cvc='asset4Value'
              value={chargeValueITR.asset4ValueF4}
              formula={chargeValueITR.asset4Formula}
              details={details}
            />
            <RowUI
              cvc='asset5Value'
              value={chargeValueITR.asset5ValueF4}
              formula={chargeValueITR.asset5Formula}
              details={details}
            />
            <RowUI
              cvc='liabilityTotal'
              value={chargeValueITR.liabilityTotalF4}
              total={true}
              details={details}
            />
            <RowUI
              cvc='liability1Value'
              value={chargeValueITR.liability1ValueF4}
              formula={chargeValueITR.liability1Formula}
              details={details}
            />
            <RowUI
              cvc='liability2Value'
              value={chargeValueITR.liability2ValueF4}
              formula={chargeValueITR.liability2Formula}
              details={details}
            />
            <RowUI
              cvc='liability3Value'
              value={chargeValueITR.liability3ValueF4}
              formula={chargeValueITR.liability3Formula}
              details={details}
            />

          </>
        }
      </tbody>
    </table>
  </div>

const RowUI = ({ cvc, value, formula, total, details }) =>
  <>
    <tr className={total && 'g_table_total'}>
      <td>
        <Desc cvc={cvc} />
      </td>
      <td className='g_text_right'>
        {value}
      </td>
    </tr>
    {
      formula && details &&
      <tr>
        <td colSpan='2' className='g_muted g_small'>
          {formula}
        </td>
      </tr>
    }
  </>

const Desc = ({ cvc }) =>
  <span>
    {(() => {
      switch (cvc) {
        case 'chargeValueFormula':
          return 'Charge Value: Last audited FY Charge + (A) - (B)'
        case 'assetTotal':
          return 'On asset side: (A) sum of the following'
        case 'asset1Value':
          return '1. Receivables from 1 Apr after audited FY till date (GST revenue reconciled with bank - reconciled collections from the bank)'
        case 'asset2Value':
          return '2. Closing cash on current date (all accounts on the date of calculation)'
        case 'asset3Value':
          return '3. Shareholder loans from 1 Apr after audited FY till date'
        case 'asset4Value':
          return '4. Equity raised from 1 Apr after audited FY till date'
        case 'asset5Value':
          return '5. Capital expenditure (?)'
        case 'liabilityTotal':
          return 'On Liability side: (B) sum of the following'
        case 'liability1Value':
          return '1. Payables from 1 Apr afer audited FY till date (GST expenses reconciled wih bank - reconciled expenses paid from the bank)'
        case 'liability2Value':
          return '2. Net outstanding new loans (i.e. total debt outstanding from CIBIL as on current date minus Net Debt in audited FY)'
        case 'liability3Value':
          return '3. Operating burn for the period from 1 Apr after audited FY till date (this can be estimated based on bank statements or from audited FY extrapolated to current period for the no of months)'
        default:
          return cvc
      }
    })()}
  </span>

export default ChargeValueItrUI
